module.exports = __webpack_public_path__ + "static/media/SDI.f4f17399.jpg";